import {Button, Spinner, Table} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {websetting} from "../../../../../../helpers/websetting";
import {Edit, Eye, Trash, Trash2} from "react-feather";
import DataTable from "react-data-table-component";

function RouteSchemes(prop:any){
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [historydata, setHistorydata] = useState([]);
    const [taskdata, setTaskdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);

    const del = (id:any) => {
    }
    const showInfo = (id:any) => {
    }
    const edit = (id:any) => {
    }

    const columns = [
        {
            name: 'Name',
            selector: (row : any) => row.node.name,
        },{
            name: 'Full Container',

            selector: (row : any) => <div>{row.node.wasteFractionsFillLevelSets.edges[0].node.wasteFraction.wasteTypes.edges[0].node.name}</div>,
        },{
            name: 'Vehicles',
            selector: (row : any) => <div>{row.vehicles != null && row.vehicles["edges"][0]["node"]["name"]}</div>,
        },{
            name: 'Schedule Day',
            selector: (row : any) => <span className={"badge outline-badge-success"}>{row.node.scheduleWeekday}</span>,
        },{
            name: 'Weeks Ahead',
            selector: (row : any) => row.node.scheduleWeeksAhead,
        },{
            name: 'Actions',
            cell : (row : any) => <div><Button variant={"danger"} onClick={()=>del(row.id)} className={"rounded-circle"}><Trash size={15} /></Button> <Button onClick={()=>edit(row.id)}  variant={"info"} className={"rounded-circle"}><Edit size={15} /></Button> <Button  variant={"dark"}  onClick={()=>showInfo(row.id)} className={"rounded-circle"}><Eye  size={15} /></Button> </div>,
        }
    ];

    const fetchDta = async (page:any) => {
        setLoading(true);
        axios.get(websetting.apiUrl + 'waste-service/api/v1/wastehero/routeSchemes/',
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setData(response.data.edges);
            setLoading(false);
        }).catch(function (error) {

        });
    };
    useEffect(() => {
        fetchDta(1); // fetch page 1 of users
    }, []);
    return(
        <div className={"lightbox mt-1"}>
            <div className={"pagetitle text-uppercase"}>
                <Trash2 className={"feather"} />
                <span className={"d-inline-block text-uppercase mx-2"}>Route Schemes</span>
            </div>

            <hr className={"shodow-hr"} />
            <div>
                {
                    loading ? <div className={"text-center"}><Spinner animation={"border"} className={"my-5 "} variant={"warning"} /></div> : <DataTable pagination paginationPerPage={10} columns={columns} data={data} />
                }


            </div>

        </div>
    );
}
export default RouteSchemes